import { createApp, h } from 'vue';
import {createInertiaApp, usePage} from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { router } from '@inertiajs/vue3';
import { createGtag, pageview,config, set } from 'vue-gtag';
import * as Sentry from "@sentry/vue";

import 'flowbite';
import '../sass/app.scss';
import {i18n} from "@/app/locale.js";
import {doOnboarding} from "@/app/onboarding.js";
import {initNotifications} from "@/features/notifications/composables/useNotifications.js";
import {registerBroadcastEvents} from "@/app/broadcast/broadcast.js";

import { deferredPromptRef } from '@/shared/helpers/system.js';
import { getBrowserType } from '@/shared/helpers/system.js';

if (getBrowserType() === 'chrome') {
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPromptRef.value = e;
    });
}

const appName = import.meta.env.VITE_APP_NAME || 'How to spanish';

createInertiaApp({
    title: (title) => title ? `${title} - ${appName}` : `${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob('./pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(i18n)

        app.use(createGtag({
            config: {
                id: 'G-DJDB273H6R'
            }
        }));

        const user = props.initialPage.props.auth.user;

        if (user) {
            config({
                'user_id': user.id
            });

            set({
                'user_properties': {
                    'language_level': user.language_level_id,
                    'native_language_id': user.language_id
                }
            });
        }

        //import.meta.env.MODE === 'production' &&
        if (import.meta.env.VITE_SENTRY_VUE_DSN) {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
                sendDefaultPii: true,
                environment: import.meta.env.MODE,
                tracesSampleRate: 1.0,
                trackComponents: true,
                integrations: [
                    // Optional: Add BrowserTracing for performance monitoring
                    Sentry.browserTracingIntegration({
                        // Disable automatic routing instrumentation since Inertia handles routing
                        instrumentNavigation: false,
                        instrumentPageLoad: false,
                    }),
                    Sentry.replayIntegration()
                ],
                logErrors: true,
                // Session Replay
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
        }

        registerBroadcastEvents();

        app.mount(el);

        return app;
    },
    progress: {
        color: '#4B5563',
    },
}).then(() => {
    initNotifications();
    trackPageView(window.location.pathname);
    doOnboarding();
});

function trackPageView(path) {
    pageview({
        page_path: path
    });
}

router.on('success', (event) => {
    const path = event.detail.page.url;
    trackPageView(path);
    doOnboarding();
});

